import React, {Component} from 'react';
import Header from './components/Header';
import PropTypes from 'prop-types';
import {MemoryRouter, Route, Switch} from 'react-router-dom';
import Home from './pages/Home';
import Activities from './pages/registry/Activities';
import Companies from './pages/registry/Companies';
import Departments from './pages/registry/Departments';
import Agents from './pages/registry/Agents';
import HPhrases from './pages/registry/HPhrases';
import RPhrases from './pages/registry/RPhrases';
import Lots from './pages/registry/Lots';
import Substances from './pages/Substances';
import DepartmentActivities from './pages/DepartmentActivities';
import DepartmentSubstances from './pages/DepartmentSubstances';
import DepartmentsCopy from './pages/DepartmentsCopy';
import SubstancesManagement from './pages/SubstancesManagement';
import Users from './pages/Users';
import Logs from './pages/Logs';
import Import from './pages/Import';
import ImportUsers from './pages/ImportUsers';
import VeriskSend from './pages/VeriskSend';
import VeriskAutoSend from './pages/VeriskAutoSend';
import VeriskBatchSend from './pages/VeriskBatchSend';
import Login from './pages/Login';
import ChangePassword from './pages/ChangePassword';
import './App.css';
import {withRoles} from './components/container/WithRole';
import {Redirect} from 'react-router';
import logo from './images/jsb.png';
import AcknowlegmentSDS from './pages/AcknowlegmentSDS';
import AcknowlegmentSDSHistory from './pages/AcknowlegmentSDSHistory';
import {fetchGet} from "./cruds/remote";
import Machineries from "./pages/registry/Machineries";

const IT_LOCALE = 'it';
const EN_LOCALE = 'en';

const MainApp = ({ handleLocaleChange, onRequestPasswordChange }) => {
  return (
      <MemoryRouter>
        <div>
            <Header onLocaleChange={handleLocaleChange} onRequestPasswordChange={onRequestPasswordChange} /> :
            <Switch>
              <Route exact path="/">
                  {withRoles(['F']) ? <Redirect to="/substances/searchResult"/> : <Home/>}
              </Route>
              <Route exact path='/' component={Home}/>
              <Route path='/substances/management' component={SubstancesManagement}/>
              <Route path='/departments/activities' component={DepartmentActivities}/>
              <Route path='/departments/substances' component={DepartmentSubstances}/>
              <Route path='/departments/copy' component={DepartmentsCopy}/>
              <Route path='/substances' component={Substances}/>
              <Route path='/departments' component={Departments}/>
              <Route path='/activities' component={Activities}/>
              <Route path='/agents' component={Agents}/>
              <Route path='/companies' component={Companies}/>
              <Route path='/machineries' component={Machineries}/>
              <Route path='/h-phrases' component={HPhrases}/>
              <Route path='/r-phrases' component={RPhrases}/>
              <Route path='/lots' component={Lots}/>
              <Route path='/users' component={Users}/>
              <Route path='/logs' component={Logs}/>
              <Route path='/import' component={Import}/>
              <Route path='/ImportUsers' component={ImportUsers}/>
              <Route path='/verisksend' component={VeriskSend}/>
              <Route path='/veriskautosend' component={VeriskAutoSend}/>
              <Route path='/veriskbatchsend' component={VeriskBatchSend}/>
              <Route path='/acknowlegmentSDS' component={AcknowlegmentSDS}/>
              <Route path='/acknowlegmentSDS/history' component={AcknowlegmentSDSHistory}/>
            </Switch>
            <div className="footer">
              <a href="https://www.jsb-solutions.com/it"><img src={logo} alt="jsb"  style={{width: "65px"}}/></a>
            </div>
          </div>
      </MemoryRouter>
  );
};

class App extends Component {
  constructor(props) {
    super(props);

    let baseLocale = localStorage.getItem('locale');
    if (!baseLocale) {
      baseLocale = IT_LOCALE;
      localStorage.setItem('locale', baseLocale);
    }

    this.state = {
      locale: baseLocale ? baseLocale : IT_LOCALE,
      isLoading: true,
      isLoggedIn: true,
      isPasswordChange: false,
    };
  }

  componentDidMount = () => {
    const token = localStorage.getItem('x-auth-token');
    const isLoggedIn = token !== undefined && token !== null;

    if (isLoggedIn) {
      // load configurations
      fetchGet('config').then(config => {
        // load user
        fetchGet('auth/loggedUser')
          .then(user => {
            localStorage.setItem('loggedUser', JSON.stringify(user));
            this.setState({isLoading: false, isLoggedIn, config});
          });
      });

    } else {
      this.setState({isLoading: false, isLoggedIn,});

    }
  };

  getChildContext = () => (
    {
      locale: this.state.locale,
      config: this.state.config,
    }
  );

  handleLocaleChange = () => {
    const newLocale = this.state.locale === IT_LOCALE ? EN_LOCALE : IT_LOCALE;
    localStorage.setItem('locale', newLocale);
    window.location = '/';
  };

  handleSuccessfulLogin = () => {
    // load configurations
    fetchGet('config').then(config => {
      this.setState({
        config,
        isLoggedIn: true,
        isPasswordChange: false,
      });
    });

  };

  handlePasswordChangeRequired = () => {
    this.setState({
      isLoggedIn: true,
      isPasswordChange: true,
    });
  };

  handleSuccessfulPasswordChange = () => {
    localStorage.removeItem('x-auth-token');
    localStorage.removeItem('loggedUser');

    this.setState({
      isLoggedIn: false,
      isPasswordChange: false,
      passwordChanged: true,
    });
  };

  renderApp = () => {
    const { isLoading, isLoggedIn, isPasswordChange, passwordChanged, locale } = this.state;

    if (isLoading) {
      return '';
    }

    if (!isLoggedIn) {
      return <Login locale={locale}
                onSuccessfulLogin={this.handleSuccessfulLogin}
                onPasswordChange={this.handlePasswordChangeRequired}
                passwordChanged={passwordChanged}
             />;
    }

    if (isPasswordChange) {
      return <ChangePassword locale={locale}
                onSuccessfulChange={this.handleSuccessfulPasswordChange}
             />;
    }

    return <MainApp handleLocaleChange={this.handleLocaleChange}
              onRequestPasswordChange={this.handlePasswordChangeRequired}
           />;

  };

  render() {
    return (
      <div className="App">{this.renderApp()}</div>
    );
  }

}

App.childContextTypes = {
  locale: PropTypes.string,
  config: PropTypes.object
};

export default App;



// WEBPACK FOOTER //
// ./src/main/App.js